/**
 * 物料計劃列 → draft-batch items[]（camel；API 層再 keysToSnake）。
 * @param {object[]} rows
 * @param {{
 *   scheduledStartDate: string,
 *   processingFactoryId: string,
 *   workWarehouseId: string,
 *   targetWarehouseId: string,
 *   issueReason?: string|null,
 *   remark?: string|null,
 * }} batchFields
 */
export function buildDraftBatchItemsFromRows(rows, batchFields) {
  const list = Array.isArray(rows) ? rows : [];
  return list
    .filter((row) => row?.selected)
    .map((row) => {
      const qty = Number(row.manufacturingQty);
      const bomMaterialSelections = (row.bomMaterialSelections ?? [])
        .filter((item) => item?.sourceGroupMaterialId && item?.selectedMaterialId)
        .map((item) => ({
          sourceGroupMaterialId: item.sourceGroupMaterialId,
          selectedMaterialId: item.selectedMaterialId,
        }));

      return {
        scheduledStartDate: batchFields.scheduledStartDate,
        mtrId: row.mtrId,
        processingFactoryId: batchFields.processingFactoryId,
        workWarehouseId: batchFields.workWarehouseId,
        targetWarehouseId: batchFields.targetWarehouseId,
        manufacturingQty: Number.isFinite(qty) ? qty : 0,
        bomMaterialSelections,
        issueReason: batchFields.issueReason || null,
        remark: batchFields.remark || null,
      };
    });
}
